var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"side-panel-heading breadcrumb-nav cf",attrs:{"id":"template-breadcrumbs"}},[_c('li',{on:{"click":_vm.deselectModule}},[_vm._v("Email Template")]),_vm._l((_vm.crumbs),function(crumb){return _c('li',{key:crumb.id},[_vm._v(_vm._s(crumb))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }